/* TDS — paginazione a puntini per <slider-component>: un puntino per pagina,
   quello attivo diventa una lineetta. Sostituisce il contatore "1 / 3".
   Va dentro .slider-buttons, dove le frecce restano nel DOM (SliderComponent
   esce subito se non trova il bottone "next") ma sono nascoste via CSS. */

if (!customElements.get('tds-slider-dots')) {
  customElements.define(
    'tds-slider-dots',
    class TdsSliderDots extends HTMLElement {
      connectedCallback() {
        this.sliderComponent = this.closest('slider-component');
        if (!this.sliderComponent || !this.sliderComponent.slider) return;

        this.sliderComponent.addEventListener('slideChanged', () => this.render());
        // Il numero di pagine cambia col breakpoint: il ResizeObserver del tema
        // ricalcola totalPages, il nostro (registrato dopo, quindi eseguito
        // dopo) ridisegna i puntini.
        new ResizeObserver(() => this.render()).observe(this.sliderComponent.slider);
        this.render();
      }

      render() {
        const total = this.sliderComponent.totalPages || 0;

        if (this.childElementCount !== total) {
          this.replaceChildren(
            ...Array.from({ length: total }, (_, index) => {
              const dot = document.createElement('button');
              dot.type = 'button';
              dot.className = 'tds-slider-dot';
              dot.setAttribute('aria-label', index + 1);
              dot.addEventListener('click', () =>
                this.sliderComponent.setSlidePosition(index * this.sliderComponent.sliderItemOffset)
              );
              return dot;
            })
          );
        }

        const current = this.sliderComponent.currentPage || 1;
        Array.from(this.children).forEach((dot, index) => {
          const isActive = index === current - 1;
          dot.classList.toggle('tds-slider-dot--active', isActive);
          dot.setAttribute('aria-current', isActive);
        });
      }
    }
  );
}
